import {NoDataPlaceholder as NoDataPlaceholder} from 'src/components';

import './styles.css';

export const ImpactChartNoDataPlaceholder = ({error}: {error: boolean}) => (
  <NoDataPlaceholder>
    <p className="ImpactChartNoDataPlaceholder__text">
      {error ? 'Error loading impact chart' : 'No data' }
    </p>
  </NoDataPlaceholder>
);
